import React from 'react';

const LoadingSpinner = () => {
  return (
    <output className="loading-spinner" aria-live="polite" aria-atomic="true">
      <div className="loading-spinner__gif">
        <img src="/dist/assets/images/panda-spinner-v2-6.gif" alt="" aria-hidden="true" width="120" height="120" />
      </div>
      <span className="loading-spinner__sr-only">Loading…</span>
    </output>
  );
};

export default LoadingSpinner;
